/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasty_Aqua_Kitten_AffirmInputs */

const fr_tasty_aqua_kitten_affirm = /** @type {(inputs: Tasty_Aqua_Kitten_AffirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune section pour cette séance a été trouvée`)
};

/**

* @param {Tasty_Aqua_Kitten_AffirmInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tasty_aqua_kitten_affirm = /** @type {((inputs?: Tasty_Aqua_Kitten_AffirmInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasty_Aqua_Kitten_AffirmInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tasty_aqua_kitten_affirm(inputs)
});